module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Change Avatar",
      "size": "lg",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "bg-gray-100 border-b mb-8 border-solid border-gray-200 px-7 py-4 flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex items-center space-x-5 text-blueGray-600"
  }, [_c('div', [_c('button', {
    staticClass: "rounded-full bg-gray-200"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-info p-2 text-blueGray-600"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('span', {
    staticClass: "block"
  }, [_vm._v("Pick one avatar from the list below or upload your own image.")]), _vm._v(" "), _c('div', [_vm._v("\n          Allowed types: jpeg, png, gif;\n          "), _c('span', {
    staticClass: "text-red-500"
  }, [_vm._v("Size limit: 2MB.")])])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "px-5 py-2 rounded cursor-pointer bg-blueGray-600 text-white disabled:opacity-50",
    attrs: {
      "disabled": _vm.is_uploading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showFilePicker.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.is_uploading ? 'Uploading...' : 'Upload Image') + "\n      ")]), _vm._v(" "), _c('input', {
    ref: "filepicker",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/x-png,image/gif,image/jpeg,image/webp"
    },
    on: {
      "change": function($event) {
        return _vm.validateFile($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col h-full overflow-y-auto px-7 pb-4"
  }, [_c('div', {
    staticClass: "flex-grow w-full"
  }, [_c('div', {
    staticClass: "grid grid-cols-6 sm:grid-cols-8 md:grid-cols-11 gap-1 border border-solid border-gray-200 rounded px-5 bg-gray-50 py-5"
  }, _vm._l((_vm.galleryList), function(avatar, index) {
    return _c('div', {
      key: index
    }, [_c('img', {
      staticClass: "h-16 w-16 rounded-full border-2 p-1 border-solid border-gray-200 cursor-pointer",
      class: {
        'border-2 border-solid border-pinky': _vm.avatarSelected === avatar,
      },
      attrs: {
        "src": avatar.pathLong
      },
      on: {
        "click": function($event) {
          return _vm.selectedAvatar(avatar)
        }
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "mx-7 my-6"
  }, [_c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('span', {
    staticClass: "mr-3 text-xs text-gray-500"
  }, [_vm._v(" Preview: ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.avatarSelected && _vm.avatarSelected.pathLong && !_vm.is_uploading),
      expression: "avatarSelected && avatarSelected.pathLong && !is_uploading"
    }],
    staticClass: "h-12 w-12 rounded-full border-2 p-1 border-solid border-gray-200 cursor-pointer",
    attrs: {
      "src": _vm.avatarSelected.pathLong
    }
  }), _vm._v(" "), (_vm.is_uploading) ? _c('div', {
    staticClass: "h-16 w-16 flex items-center"
  }, [_c('pl-spinner', {
    staticClass: "x1"
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('button', {
    staticClass: "bg-gray-100 border border-solid border-gray-200 px-5 py-2 text-blueGray-600 rounded",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "bg-primary border font-medium border-solid border-primary px-5 py-2 text-white rounded",
    attrs: {
      "disabled": _vm.is_uploading
    },
    on: {
      "click": function($event) {
        return _vm.saveAvatar()
      }
    }
  }, [_vm._v("\n          Save and Close\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-cf9aa748!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/chooseAvatar.vue
// module id = 1601
// module chunks = 61